import React, { useEffect } from 'react'
import Network, { BaseURL, BetaUrl } from '../utils/Network'
import { EventConfig, GameAnnouncements } from '../types/global'
import { useDispatch, useSelector } from 'react-redux'
import { setAnnouncements } from '../redux/announcements/action'
import { setEventConfig } from '../redux/events/action'
import { useAppTranslation } from '../i18n/useAppTranslation'

type Props = {}

const useAnnouncements = () => {
  const axios = new Network()
  const dispatch = useDispatch();
  const { currentLanguage } = useAppTranslation();
  const getAnnouncements = async () => {
    const response = await axios.CallApi<GameAnnouncements>({ url: "/api/v2/announcement/getall", method: "GET", customHost: BaseURL })
    if (response.ok) {
      dispatch(setAnnouncements({ ...response.data, fetchedAt: Date.now() }))
    }
  }

  const getEventShopConfig = async () => {
    const response = await axios.CallApi<EventConfig>({ url: "/api/v2/event/getevent?key=IsEventShopOpen", method: "GET", customHost: BaseURL })
    if (response.ok) {
      dispatch(setEventConfig(response.data))
    }
  }


  // Announcements are written in the chosen language by the server, so they are read again when it changes.
  useEffect(() => {
    getEventShopConfig()
    getAnnouncements()
  }, [currentLanguage])

}

export default useAnnouncements